'use client'

import { useTranslation } from '@/hooks/client/use-translation'

export const PopupTemplateLoading = () => {
  const { t } = useTranslation()
  return (
    <div className="bg-cream min-h-80 space-y-5 p-6 md:p-8" role="status" aria-busy="true">
      <p className="sr-only">{t('popup.loading', 'Loading…')}</p>
      <div aria-hidden className="space-y-5 motion-safe:animate-pulse">
        <div className="bg-navy-10 h-4 w-28 rounded" />
        <div className="bg-navy-10 h-12 max-w-sm rounded-lg" />
        <div className="space-y-2">
          <div className="bg-navy-5 h-4 rounded" />
          <div className="bg-navy-5 h-4 w-3/4 rounded" />
        </div>
        <div className="bg-navy-10 mt-8 h-12 rounded-xl" />
      </div>
    </div>
  )
}
